import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class IdentityProviderIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async list() {
        try {
            const response = await this.service.list();
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async create(payload) {
        try {
            const response = await this.service.create(payload);
            toast.success(i18next.t('definitionsNav:identityProviders.messages.created', { defaultValue: 'Identity provider created.' }));
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async update(id, payload) {
        try {
            const response = await this.service.update(id, payload);
            toast.success(i18next.t('definitionsNav:identityProviders.messages.updated', { defaultValue: 'Identity provider updated.' }));
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async remove(id) {
        try {
            await this.service.remove(id);
            toast.success(i18next.t('definitionsNav:identityProviders.messages.deleted', { defaultValue: 'Identity provider deleted.' }));
            return { success: true };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async rotateApiKey(id) {
        try {
            const response = await this.service.rotateApiKey(id);
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async testOidc(id) {
        try {
            const response = await this.service.testOidc(id);
            toast.success(i18next.t('definitionsNav:identityProviders.messages.discovered', { defaultValue: 'OIDC endpoints discovered.' }));
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    _getErrorMessage(error) {
        return getIntegrationErrorMessage(error);
    }
}
